class VariantFAQs extends HTMLElement {
	constructor() {
		super();
	}
	connectedCallback() {
		document.addEventListener('variant:change', (event) => {
			this.updateFAQs(event);
		});
		document.addEventListener('DOMContentLoaded', () => {
			this.section = this.closest('section');
			this.faqContent = this.section.querySelector('.faq__content');
			this.directAccordionItems = this.faqContent.querySelectorAll(':scope > .accordion');
			this.hideSection();
		});
	}

	updateFAQs(event) {
		const variant = event.detail.variant;
		Array.from(this.children).forEach((faq) => {
			const faqId = faq.getAttribute('data-variant-id');

			if (parseInt(faqId) === variant.id) {
				faq.classList.remove('hidden');
			} else {
				faq.classList.add('hidden');
			}
		});
		this.hideSection();
	}

	hideSection() {
		this.directHiddenChildren = Array.from(this.children).filter((child) => child.matches('.hidden'));
		if (this.directHiddenChildren.length === this.childElementCount && this.directAccordionItems.length === 0) {
			this.section.classList.add('hidden');
		} else {
			this.section.classList.remove('hidden');
		}
	}
}

if (!window.customElements.get('variant-faqs')) {
	window.customElements.define('variant-faqs', VariantFAQs);
}
